import { booleanAttribute, ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UpperCasePipe } from '@angular/common';
import { AvailableLanguages, LANGUAGES } from '@core/components/header/lang-selection/lang-selection.config';
import { TranslateModule } from '@ngx-translate/core';
import { AcTranslationService } from '@core/services/translation/ac-translation.service';
import { CustomLinkDirective } from '@shared/directives/custom-link/custom-link.directive';
import { featureFlags } from '@shared/constants/feature-flags';
import { Store } from '@ngrx/store';
import { StoreState } from '@store/store.state';
import { languageSelectors } from '@store/selectors/language.selectors';

@Component({
  selector: 'ac-lang-selection',
  standalone: true,
  templateUrl: './lang-selection.component.html',
  styleUrls: ['./lang-selection.component.scss'],
  imports: [TranslateModule, UpperCasePipe, CustomLinkDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LangSelectionComponent {
  @Input({ transform: booleanAttribute }) side = false;
  protected readonly _languages = LANGUAGES;
  protected readonly _currentLangSig = this._acTranslationService.langSig;
  protected readonly _visibility = this._store.selectSignal(languageSelectors.visibilityLang);

  constructor(
    private readonly _acTranslationService: AcTranslationService,
    private readonly _store: Store<StoreState>
  ) {}

  setLanguage(lang: AvailableLanguages) {
    this._acTranslationService.changeLang(lang);
  }

  protected readonly shouldRenderLangSelection: boolean = featureFlags.translationFeatureFlag;
}
